$(document).ready(function () {
  // The main POS answers when the app has printed (see MainPosHandlers.js, kind 'web_print')
  function showPrintResult(request, button, buttonText) {
    const showError = function (messageKey) {
      const errorMessage = $('#web-print-error-container').data(messageKey);
      $('#web-print-error-container').html(getAlertHtml(errorMessage, 'danger'));
    };

    request
      .done(function (reply) {
        button.prop('disabled', false);
        button.html(buttonText);
        const orderIds = reply && reply.data && reply.data.orderIds;
        if (Array.isArray(orderIds) && orderIds.length == 0) {
          showError('print-failed');
        }
      })
      .fail(function (err) {
        button.prop('disabled', false);
        button.html(buttonText);
        showError(
          err && err.code === 'main_offline'
            ? 'main-pos-unavailable'
            : 'print-failed'
        );
      });
  }

  $(document).on('click', '.print-order-from-web', function (event) {
    event.preventDefault();
    const button = $(this);
    const printerType = button.attr('data-printer-type') || null;
    const printerIpAddress = button.attr('data-printer-ip') || null;

    if (OnDevice.byPrinterType(printerType) && !isNaN(printerIpAddress)) {
      if (typeof SocketHub === 'undefined' || !SocketHub.pos) {
        showTerminalNotReady('not_initialized');
        return;
      }

      const ready = SocketHub.pos.check(printerIpAddress);
      if (!ready.ok) {
        showTerminalNotReady(ready.code);
        return;
      }
    }

    const buttonText = button.html();
    const locationId = button.data('location-id');
    const orderData = button.data('order-data');
    const mainPosDeviceId = button.data('main-pos-id');
    const deviceId = localStorage.getItem('deviceID') || 'unknown_device';
    const receiptType = button.attr('data-receipt-type') || '';

    if (OnDevice.byPrinterType(printerType)) {
      const printDocumentData = button.data('print-document');
      const printSegments = button.data('print-segments') || [];
      let printDocument = '';

      if (Array.isArray(printDocumentData)) {
        printDocumentData.map((printData) => {
          printDocument += printData;
        });
      } else {
        printDocument = printDocumentData;
      }

      // the terminal (any on-device solution) is addressed by its unique id; PAX prints from segments
      const res = SocketHub.pos.print(
        printerIpAddress, // the terminal id
        printDocument, // HTML
        { meta: { orderId: null }, segments: printSegments },
        function (job) {
          // optional: called on every state change
          if (job.state === 'dispatched') {
            // the terminal received it and handed it to its printer
          }
        }
      );

      if (!res.ok) {
        showTerminalNotReady(res.code); // channel_offline | terminal_offline | unsupported | bad_request | send_failed
      }

      return;
    }

    $('#web-print-error-container').html('');

    if (window.ReactNativeWebView) {
      if (receiptType == 'advance_receipt') {
        if (mainPosDeviceId && mainPosDeviceId !== deviceId) {
          checkDeviceActive(mainPosDeviceId).then(function (isActive) {
            if (isActive) {
              let socketData = {
                printData: {
                  action: 'advance_receipt',
                  data: orderData.orderProducts,
                  ip: printerIpAddress || orderData.ipAddress,
                  type: printerType || orderData.printerType,
                  organizer: orderData.organizer,
                  order: null,
                  deviceId: deviceId,
                  tableNumber: orderData.tableNumber,
                  personName: orderData.tableCustomerName,
                },
              };

              sendToMainPos('print_service', { printData: socketData.printData });
            } else {
              showToast({
                type: 'error',
                message:
                  'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
              });
            }
          });
        } else {
          passDataToWebView(
            event,
            'advance_receipt',
            orderData.orderProducts,
            printerIpAddress || orderData.ipAddress,
            printerType || orderData.printerType,
            orderData.organizer,
            null,
            deviceId,
            orderData.tableNumber,
            orderData.tableCustomerName
          );
        }
      } else if (receiptType == 'supply_list') {
        if (mainPosDeviceId && mainPosDeviceId !== deviceId) {
          checkDeviceActive(mainPosDeviceId).then(function (isActive) {
            if (isActive) {
              let socketData = {
                printData: {
                  action: 'supply_list',
                  data: orderData.orderProducts,
                  ip: orderData.ipAddress,
                  type: orderData.printerType,
                  organizer: orderData.organizer,
                  order: null,
                  deviceId: deviceId,
                  tableNumber: '',
                  personName: '',
                },
              };

              sendToMainPos('print_service', { printData: socketData.printData });
            } else {
              showToast({
                type: 'error',
                message:
                  'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
              });
            }
          });
        } else {
          passDataToWebView(
            event,
            'supply_list',
            orderData.orderProducts,
            orderData.ipAddress,
            orderData.printerType,
            orderData.organizer,
            null,
            deviceId,
            '',
            ''
          );
        }
      } else {
        if (mainPosDeviceId && mainPosDeviceId !== deviceId) {
          checkDeviceActive(mainPosDeviceId).then(function (isActive) {
            if (isActive) {
              unshorten(orderData, function (data) {
                let socketData = {
                  printData: {
                    action: 'web_print_order',
                    data: data,
                    ip: null,
                    type: null,
                    organizer: null,
                    order: null,
                    deviceId: deviceId,
                    tableNumber: '',
                    personName: '',
                  },
                };
                sendToMainPos('print_service', { printData: socketData.printData });
              });
            } else {
              showToast({
                type: 'error',
                message:
                  'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
              });
            }
          });
        } else {
          unshorten(orderData, function (data) {
            passDataToWebView(
              event,
              'web_print_order',
              data,
              null,
              null,
              null,
              null,
              deviceId,
              '',
              ''
            );
          });
        }
      }
    } else {
      button.prop('disabled', true);
      button.html('<div class="loader"></div>');
      checkDeviceActive(mainPosDeviceId)
        .then(function (isActive) {
          if (isActive) {
            let request = null;
            if (receiptType == 'advance_receipt') {
              request = {
                kind: 'advance_receipt',
                orderProducts: orderData.orderProducts,
                ipAddress: printerIpAddress || orderData.ipAddress,
                printerType: printerType || orderData.printerType,
                organizer: orderData.organizer,
                tableNumber: orderData.tableNumber,
                tableCustomerName: orderData.tableCustomerName,
              };
            } else if (receiptType == 'supply_list') {
              request = {
                kind: 'supply_list',
                orderProducts: orderData.orderProducts,
                ipAddress: printerIpAddress || orderData.ipAddress,
                printerType: printerType || orderData.printerType,
                organizer: orderData.organizer,
                tableNumber: '',
                tableCustomerName: '',
              };
            } else {
              unshorten(orderData, function (data) {
                showPrintResult(
                  sendToMainPos(
                    'web_print',
                    { kind: 'web_print_order', order_data: data },
                    { timeout: 12000 }
                  ),
                  button,
                  buttonText
                );
              });
              return;
            }

            showPrintResult(
              sendToMainPos('web_print', request, { timeout: 12000 }),
              button,
              buttonText
            );
          } else {
            button.prop('disabled', false);
            button.html(buttonText);
            const errorMessage = $('#web-print-error-container').data(
              'main-pos-unavailable'
            );
            const alertHtml = getAlertHtml(errorMessage, 'danger');
            $('#web-print-error-container').html(alertHtml);
          }
        })
        .catch(function (error) {
          button.prop('disabled', false);
          button.html(buttonText);
          const errorMessage = $('#web-print-error-container').data(
            'main-pos-unavailable'
          );
          const alertHtml = getAlertHtml(errorMessage, 'danger');
          $('#web-print-error-container').html(alertHtml);
        });
    }
  });
});

// Is a main POS connected right now? The server routes to the current main POS, so the id is not needed.
function checkDeviceActive() {
  return new Promise((resolve) => {
    SocketHub.ensurePos({ features: ['main'] })
      .done(function () {
        resolve(SocketHub.main.online());
      })
      .fail(function () {
        resolve(false);
      });
  });
}
